import axios from "axios";

const serverUrl = process.env.VUE_APP_URL;

export default {
    methods: {
        newDelivery(baseForm){
            var url = `${serverUrl}Delivery/AddDelivery`;
            return   axios.post(url, baseForm)
        },
        getRawMaterialDeliveryById(deliveryId) {
            var url = `${serverUrl}Delivery/GetRawMaterialDeliveryById/${deliveryId}`;
            return axios.get(url);
        },
        updateRawMaterialDelivery(form) {
            var url = `${serverUrl}Delivery/UpdateDelivery`;
            return axios.post(url, form)
        },
        removeDelivery(deliveryId) {
            var url = `${serverUrl}Delivery/RemoveRawMaterialDelivery`;
            return axios.post(url, { rawMaterialDeliveryId: deliveryId })
        },
        registerMaterialLoss(typeOfLoss, itemId, weightToReduce) {
            var url = `${serverUrl}`;

            switch (typeOfLoss) {
                case "couverture":
                    url += "Couverture/MaterialLoss";
                    break;
                case "coatingProduct":
                    url += "CoatingProduct/MaterialLoss";
                    break;
                case "rawMaterial":
                    url += "RawMaterials/MaterialLoss";
                    break;
            }

            var data = {
                itemId,
                weight: parseFloat(weightToReduce),
            };

            return axios.post(url, data)
        },
        getCurrentStockLevels(filters, page) {
            var url = `${serverUrl}Delivery/GetNotEmptyRawMaterials?page=${page}&itemsPerPage=${filters.itemsPerPage}`;
            if (filters.rawMaterialTypeId) {
                url = `${url}&RawMaterialTypeId=${filters.rawMaterialTypeId.id}`;
            }
            if (filters.productType) {
                url = `${url}&ProductType=${filters.productType.value}`;
            }

            return axios.get(url)
        }
    },
    data() {
        return {
            rawMaterialTypeEko: 0,
            rawMaterialTypeKonwencja: 1,
            rawMaterialTypes: [
                { text: 'EKO', value: 0 },
                { text: 'KONWENCJA', value: 1 },
            ]
        }
    }
};
